import { ContentLayout } from 'layouts/ContentLayout/ContentLayout';
import CustomRoleHeader from './CustomRoleHeader';
import { useNavigate } from 'react-router-dom';
import { FormProvider, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { CustomRoleSchema } from './Form/schema';
import { CustomRoleFormType } from './custom-roles.types';
import { useMutation, useQueryClient } from 'react-query';
import { postCustomRole } from '../utils';
import showToast from 'components/Toast/Toast';
import Form from './Form/Form';
import { getCustomRolePermissions } from './utils';

const CreateCustomRole = () => {
  const navigate = useNavigate();

  const methods = useForm<CustomRoleFormType>({
    resolver: zodResolver(CustomRoleSchema),
    defaultValues: {
      name: '',
      description: '',
      color: '',
      permissions: [],
    },
  });

  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation(postCustomRole, {
    onSuccess: (data) => {
      showToast.confirmation({
        title: 'Role created!',
        message: `${data?.name}`,
      });
      queryClient.refetchQueries('custom-roles-index-table');
      navigate(`/users/custom-roles`);
    },
  });

  const onSubmit = (data: CustomRoleFormType) => {
    mutate({
      ...data,
      permissions: getCustomRolePermissions(data.permissions ?? []),
    });
  };

  return (
    <ContentLayout className="min-h-screen !justify-start">
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(onSubmit)}
          className="flex flex-1 flex-col"
        >
          <CustomRoleHeader
            title="Create role"
            breadcrumbs={[{ label: 'Create role' }]}
            isDirty={methods.formState.isDirty}
            withUnsavedChangeModal={true}
            buttonAction={{
              onClick: () => {},
              children: 'Create role',
              disabled: isLoading,
              type: 'submit',
              size: 'large',
              className: 'md:w-max w-full',
            }}
          />
          <Form />
        </form>
      </FormProvider>
    </ContentLayout>
  );
};

export default CreateCustomRole;
